import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

const PREFIX = config.baseApi + "/merchant/content/announcement";

/** 公告列表 query: type, unread_only, page, page_size */
export function announcementList(params) {
  return request.get(PREFIX + "/list", params);
}

/** 公告详情 */
export function announcementDetail(id) {
  return request.get(PREFIX + "/detail/" + id);
}

/** 未读数 → { count } */
export function announcementUnread() {
  return request.get(PREFIX + "/unread");
}

/**
 * 已读 / 仅记强弹
 * body: { id } 已读；{ id, only_popup: true } 只记强弹仍未读
 */
export function announcementRead(data) {
  return request.post(PREFIX + "/read", data);
}

/** 当前应强弹的一条或 null */
export function announcementPopup() {
  return request.get(PREFIX + "/popup");
}
